import React from 'react';
import { useFormContext } from 'react-hook-form';
import { ExperienceTabType } from '@components/profile/profileOverlay/overlays/experience/index';

import classnames from 'classnames/bind';
import styles from './experience.module.scss';

const cx = classnames.bind(styles);

interface IExperienceTab {
  selectedTabType: ExperienceTabType;
  setSelectedTabType: (selectedTab: ExperienceTabType) => void;
}
const ExperienceTab = ({ selectedTabType, setSelectedTabType }: IExperienceTab) => {
  const isOn = (tabType: ExperienceTabType) => tabType === selectedTabType;
  const {
    formState: { errors },
  } = useFormContext();

  return (
    <div className={cx('tabArea')}>
      <a
        // [D] 선택된 탭은 'on' 클래스 / 에러인 경우 'error' 클래스 추가
        className={cx('tab', { on: isOn('ACTIVITY') }, { error: errors.activities })}
        role="button"
        onClick={() => setSelectedTabType('ACTIVITY')}
      >
        대내외 활동
      </a>
      <a
        className={cx('tab', { on: isOn('OVERSEAS') }, { error: errors.foreignExperiences })}
        role="button"
        onClick={() => setSelectedTabType('OVERSEAS')}
      >
        해외 경험
      </a>
      <a
        className={cx('tab', { on: isOn('ETC_EXPERIENCE') })}
        role="button"
        onClick={() => setSelectedTabType('ETC_EXPERIENCE')}
      >
        기타 경험
      </a>
    </div>
  );
};

export default ExperienceTab;
